import { useMemo } from 'react';
import { useClientReferenceFieldNames } from './useClientReferenceFieldNames';
import { useClientReferenceFieldValues } from './useClientReferenceFieldValues';
import { useRefreshClientReferenceFields } from './useRefreshClientReferenceFields';
const refreshWhenStale = (query)=>query.isStale();
export function useClientReferenceFieldsData() {
    const { fields } = useClientReferenceFieldNames({
        refreshOnHookMount: refreshWhenStale
    });
    const keys = useMemo(()=>fields.map((param)=>{
            let { key } = param;
            return key;
        }), [
        fields
    ]);
    const values = useClientReferenceFieldValues(keys);
    const refresh = useRefreshClientReferenceFields();
    return {
        fields,
        values,
        refresh
    };
}
